// extracted by mini-css-extract-plugin
export default {"input":"Requisite_input__WqysX","button":"Requisite_button__MK09T"};